import { render } from "./eduResearchMenu.vue?vue&type=template&id=f0ebe26a&scoped=true"
import script from "./eduResearchMenu.vue?vue&type=script&lang=js"
export * from "./eduResearchMenu.vue?vue&type=script&lang=js"

import "./eduResearchMenu.vue?vue&type=style&index=0&id=f0ebe26a&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0ebe26a"]])

export default __exports__